import { initializeApp } from "firebase/app";
import { initializeAuth, browserPopupRedirectResolver, indexedDBLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAqhqTBW7KhwKiu6H-hjfUJeXBn0mCx0V4",
  authDomain: "sarvagyaconnect.firebaseapp.com",
  projectId: "sarvagyaconnect",
  storageBucket: "sarvagyaconnect.firebasestorage.app",
  messagingSenderId: "630523345330",
  appId: "1:630523345330:web:f88940bd4d5021dbfc0cab",
  measurementId: "G-CZP04BJ9HH"
};

const app = initializeApp(firebaseConfig);
const auth = initializeAuth(app, {
  persistence: indexedDBLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});
const db = getFirestore(app);
const storage = getStorage(app);

if (typeof window !== "undefined") {
  import("firebase/analytics").then(({ getAnalytics }) => {
    getAnalytics(app);
  });
}

export { app, auth, db, storage };